<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="has-background-light" style="padding-bottom: 20px;">
      <br><h1 class="title is-4">ลงทะเบียนรถใหม่ สาขา {{ branchSelected }}</h1>
    </section>
    <section class="hero has-background-light is-fullheight" v-show="!sendQRSuccess">
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div class="container"><br>
                <p v-if="errors.length">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                  </ul><br>
                </p>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">เลขที่ Booking</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="เลขที่ Booking" v-model="carInfo.bookingNo">
                      </div>
                    </div>
                  </div>
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">เลขที่ Invoice</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="เลขที่ Invoice" v-model="carInfo.invoiceNo">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">Invoice Date</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Invoice Date" v-model="carInfo.invoiceDate">
                      </div>
                    </div>
                  </div>
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">Delivery Date</label>
                      <div class="control">
                        <input class="input" type="text" placeholder="Delivery Date" v-model="carInfo.deliveryDate">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขตัวถัง</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขตัวถัง" v-model="carInfo.frameNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ชื่อลูกค้า</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อลูกค้า" v-model="carInfo.customerName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เบอร์โทรลูกค้า</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เบอร์โทรลูกค้า" v-model="carInfo.customerTel">
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">รุ่นรถ</label>
                      <div class="select">
                        <select v-model="carInfo.Model">
                          <option v-for="model in models" v-bind:key="model" :value="model" >{{ model }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <div class="field">
                      <label class="label">สีของรถ</label>
                      <div class="select">
                        <select v-model="carInfo.carColor">
                          <option v-for="color in colors" v-bind:key="color.code" :value="color.code" >{{ color.code }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">บริษัทประกันภัย</label>
                  <div class="select">
                    <select v-model="carInfo.Insurrance">
                      <option v-for="insurrance in insurrances" v-bind:key="insurrance" :value="insurrance" >{{ insurrance }}</option>
                    </select>
                  </div>
                </div>
                <div class="field" v-show="carInfo.Insurrance == 'other'">
                  <label class="label">บริษัทประกันภัยอื่นๆ</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="บริษัทประกันภัยอื่นๆ" v-model="carInfo.insurranceOther">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขที่รับแจ้ง</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขที่รับแจ้ง" v-model="carInfo.insurranceNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ชื่อ Sales</label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อ Sales" v-model="carInfo.salesName">
                  </div>
                </div>
                <br>
                <button class="button is-success" v-on:click="submitCarInfo">{{ btn_action }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <article class="message is-success" v-show="sendQRSuccess">
      <div class="message-header">
        <p>ส่ง QR Code ไปที่ LINE Group Admin เรียบร้อยแล้ว</p>
      </div>
      <div class="message-body">
        <button class="button is-link" v-on:click="newCustomer">ลงทะเบียนรถใหม่</button>
      </div>
    </article>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'RegisterNewCar',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
    QrcodeVue
  },
  data: () => ({
    urlconfirm: 'https://liff.line.me/1653760842-Nk0KpkmE?',
    size: 200,
    registerSuccess: false,
    sendQRSuccess: false,
    errors: [],
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    branch: [],
    branchSelected: '',
    branchCode: '',
    carInfo: {
      bookingNo: '',
      invoiceNo: '',
      frameNo: '',
      customerName: '',
      customerTel: '',
      Model: '',
      carColor: '',
      Insurrance: '',
      insurranceNo: '',
      insurranceOther: '',
      invoiceDate: '',
      deliveryDate: '',
      salesName: ''
    },
    carId: '',
    btn_action: 'Submit',
    updatedBy: '',
    models: [
      '', 'Accord', 'Accord. EHEV', 'BR-V', 'WR-V', 'Brio Amaze', 'Brio', 'CR-V', 'CR-V e HEV', 'City', 'CITY HATCHBACK', 'CITY e:HEV', 'CIVIC e:Hev', 'Civic Hatchback', 'Civic', 'HR-V', 'HRV e:HEV', 'Jazz', 'Mobilio', 'CITY HATCHBACK e:HEV'
    ],
    insurrances: [
      '',
      'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน)',
      'บริษัท ธนชาตประกันภัย จำกัด (มหาชน)',
      'บริษัท คุ้มภัยโตเกียวมารีนประกันภัย (ประเทศไทย)',
      'บริษัท สมโพธิ์ เจแปน นิปปอนโคอะ ประกันภัย',
      'บริษัท แอกซ่าประกันภัย จำกัด (มหาชน)',
      'บริษัท มิตซุย สุมิโตโม อินชัวรันซ์ จำกัด',
      'บริษัท แอลเอ็มจี ประกันภัย จำกัด (มหาชน)',
      'บริษัท สินทรัพย์ประกันภัย จำกัด',
      'บริษัท สินมั่งคงประกันภัย จำกัด',
      'บริษัท เอ็ม เอส ไอ จี ประกันภัย จำกัด',
      'บริษัท ทิพยะประกันภัย จำกัด',
      'บริษัท วิริยะประกันภัย จำกัด',
      'บริษัท ไทยวิวัฒน์ จำกัด',
      'other'
    ],
    colors: [
      { 'code': 'CBL', 'title': 'Black' },
      { 'code': 'IGR', 'title': 'Red' },
      { 'code': 'LUS', 'title': 'Silver' },
      { 'code': 'MST', 'title': 'Gray' },
      { 'code': 'PAR', 'title': 'Red' },
      { 'code': 'PHO', 'title': 'Orange' },
      { 'code': 'PMW', 'title': 'White' },
      { 'code': 'RLR', 'title': 'Red' },
      { 'code': 'SNG', 'title': 'Silver' },
      { 'code': 'TTW', 'title': 'White' },
      { 'code': 'CBM', 'title': 'Cosmic Blue' },
      { 'code': 'MTS', 'title': 'Meteoroid Gray Metallic' },
      { 'code': 'OSB', 'title': 'Obsidian Blue Pearl' },
      { 'code': 'MTG', 'title': 'Meteoroid Gray Metallic' },
      { 'code': 'BSB', 'title': 'Brilliant Sporty Blue Metallic' },
      { 'code': 'PSW', 'title': 'Premium Sunlight White Pearl' },
      { 'code': 'IRB', 'title': 'IRB' },
      { 'code': 'STD', 'title': 'STD' },
      { 'code': 'CYB', 'title': 'CYB' },
      { 'code': 'SKC', 'title': 'KHAKI SAND' }
    ]
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    _this.branch = this.$branchList
    // if (process.env.NODE_ENV === 'development') {
    //   this.getProfile_dev()
    // } else {
    //   this.getProfile()
    // }
    const queryString = decodeURIComponent(decodeURIComponent(window.location.search).replace('?liff.state=', ''))
    console.log(queryString)
    const params = new URLSearchParams(queryString)
    const branchCode = params.get('branchCode')
    _this.branchCode = branchCode
    _this.branch.map((item) => {
      _this.branchSelected = (item.id === _this.branchCode) ? item.name : _this.branchSelected
      return true
    })
    this.getToday()
  },
  methods: {
    getToday () {
      const date = new Date()
      this.carInfo.expectedDate = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear()
    },
    newCustomer () {
      this.carInfo.bookingNo = ''
      this.carInfo.invoiceNo = ''
      this.carInfo.customerName = ''
      this.carInfo.customerTel = ''
      this.carInfo.frameNo = ''
      this.carInfo.Model = ''
      this.carInfo.Insurrance = ''
      this.carInfo.insurranceNo = ''
      this.carInfo.insurranceOther = ''
      this.carInfo.carColor = ''
      this.carInfo.invoiceDate = ''
      this.carInfo.deliveryDate = ''
      this.carInfo.salesName = ''
      this.btn_action = 'Submit'
      this.errors = []
      this.registerSuccess = false
      this.sendQRSuccess = false
      this.getToday()
    },
    checkForm (e) {
      if (this.carInfo.customerName && this.carInfo.customerTel && this.carInfo.frameNo && this.carInfo.deliveryDate && this.carInfo.bookingNo && this.carInfo.Model && this.carInfo.carColor && this.carInfo.salesName) {
        return true
      }

      this.errors = []
      if (!this.carInfo.bookingNo) {
        this.errors.push('กรุณากรอกเลขที่ Booking')
      }
      if (!this.carInfo.deliveryDate) {
        this.errors.push('กรุณากรอก Delivery Date')
      }
      if (!this.carInfo.frameNo) {
        this.errors.push('กรุณากรอกเลขตัวถัง')
      }
      if (!this.carInfo.customerName) {
        this.errors.push('กรุณากรอกชื่อลูกค้า')
      }
      if (!this.carInfo.customerTel) {
        this.errors.push('กรุณากรอกเบอร์โทรลูกค้า')
      }
      if (!this.carInfo.Model) {
        this.errors.push('กรุณาเลือกรุ่นรถ')
      }
      if (!this.carInfo.carColor) {
        this.errors.push('กรุณากรอกสีรถ')
      }
      if (!this.carInfo.salesName) {
        this.errors.push('กรุณากรอกชื่อ Sales')
      }
      if (this.carInfo.Insurrance && this.carInfo.Insurrance !== 'other' && !this.carInfo.insurranceNo) {
        this.errors.push('กรุณากรอกเลขที่รับแจ้ง')
      }

      e.preventDefault()
    },
    async checkFrameNo () {
      let result
      let params = {
        frameNo: this.carInfo.frameNo
      }
      await this.$axios
        .post(`${this.$apiUrl}getNewCarByFrameNo`, params)
        .then(response => {
          if (response.data.length <= 0) {
            result = true
          } else {
            result = false
          }
        })
      return result
    },
    async submitCarInfo (e) {
      this.errors = []
      let _this = this
      if (!this.checkForm(e)) {
        return false
      }
      const checkFrame = await this.checkFrameNo()
      if (!checkFrame) {
        this.errors = []
        this.errors.push('เลขที่ตัวถังซ้ำ กรุณาตรวจสอบ')
        return false
      }
      _this.btn_action = 'Waiting...'
      _this.carInfo.branchId = _this.branchCode
      let params = {
        carInfo: _this.carInfo,
        updatedBy: _this.updatedBy
      }
      this.$axios
        .post(`${this.$apiUrl}setNewCarInfo`, params)
        .then(response => {
          _this.carId = response.data.carId
          _this.urlconfirm += `branchCode=${_this.branchCode}&carId=${_this.carId}`
          _this.registerSuccess = true
          if (process.env.NODE_ENV !== 'development') {
            _this.sendQRCode()
          } else {
            // _this.sendQRSuccess = true
            _this.sendQRCode()
          }
        })
    },
    sendQRCode () {
      let _this = this
      console.log(_this.carInfo)
      this.$axios
        .get(`${this.$apiUrl}sendQRCodeToSales?customerName=${_this.carInfo.customerName}&customerTel=${_this.carInfo.customerTel}&pictureUrl=${_this.profile.pictureUrl}&frameNo=${_this.carInfo.frameNo}&Model=${_this.carInfo.Model}&carYear=${_this.carInfo.carYear}&carColor=${_this.carInfo.carColor}&branchCode=${_this.branchCode}&carId=${_this.carId}&salesName=${_this.carInfo.salesName}`)
        .then(response => {
          _this.sendQRSuccess = true
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTyqPSOkdZLRSQHV5FEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterNewCar.vue